import React from 'react';
import { I18n } from '@aws-amplify/core';
import { Tooltip } from 'antd';

import { BERA_VERSION_V2, EMPTY_VALUE } from '@/views/Bera/constants';

import type { BeraJobSummaryListItem } from '@/types/Bera';
import * as S from './styles';

interface TlidCellProps {
	report: BeraJobSummaryListItem;
	onShowTlids: (report: BeraJobSummaryListItem) => void;
}

export function TlidCell({ report, onShowTlids }: Readonly<TlidCellProps>): JSX.Element {
	const hasTlids = report.version === BERA_VERSION_V2 && report.tlid_count > 0;

	function handleClick() {
		onShowTlids(report);
	}

	if (!hasTlids) {
		return <span>{EMPTY_VALUE}</span>;
	}

	return (
		<Tooltip title={I18n.get('View TLIDs')}>
			<S.TlidLink type="link" onClick={handleClick}>
				{report.tlid_count}
			</S.TlidLink>
		</Tooltip>
	);
}
